/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Faq_3_AInputs */

const en_control_faq_3_a = /** @type {(inputs: Control_Faq_3_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. The answer appears first, followed by location, steps and troubleshooting.`)
};

const zh_control_faq_3_a = /** @type {(inputs: Control_Faq_3_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`答案在前，位置、步骤和排查说明在后。`)
};

/**
* | output |
* | --- |
* | "Yes. The answer appears first, followed by location, steps and troubleshooting." |
*
* @param {Control_Faq_3_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_faq_3_a = /** @type {((inputs?: Control_Faq_3_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Faq_3_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_faq_3_a(inputs)
	return zh_control_faq_3_a(inputs)
});
export { control_faq_3_a as "control.faq.3.a" }